import { render, staticRenderFns } from "./RequestAdditionalLicenseModal.vue?vue&type=template&id=2610712f&scoped=true"
import script from "./RequestAdditionalLicenseModal.vue?vue&type=script&lang=js"
export * from "./RequestAdditionalLicenseModal.vue?vue&type=script&lang=js"
import style0 from "./RequestAdditionalLicenseModal.vue?vue&type=style&index=0&id=2610712f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2610712f",
  null
  
)

export default component.exports